import { defineStore } from "pinia";

import type { BoardType } from "@/model/baseTypes";

export interface Settings {
  isBacklogAlmStickyDeletable: boolean;
  isTeamAlmStickyDeletable: boolean;
  isPriorityEditable: boolean;
  confirmDelete: boolean;
  moveBetweenTeams: boolean;
  mirrorAssignedBacklogStickiesToTeamBoard: boolean;
  iterationLoadWarn: number | null;
  iterationLoadCritical: number | null;
}

export const useServerSettingsStore = defineStore("serverSettings", {
  state: (): Settings => ({
    isBacklogAlmStickyDeletable: true,
    isTeamAlmStickyDeletable: true,
    isPriorityEditable: true,
    confirmDelete: true,
    moveBetweenTeams: true,
    mirrorAssignedBacklogStickiesToTeamBoard: true,
    iterationLoadWarn: null,
    iterationLoadCritical: null,
  }),
  getters: {
    isStickyDeletable: (state) => (boardType: BoardType) => {
      switch (boardType) {
        case "backlog":
          return state.isBacklogAlmStickyDeletable;
        case "team":
          return state.isTeamAlmStickyDeletable;
        default:
          return true;
      }
    },
  },
});
